(function (e, a) {
  for (var i in a) {
    e[i] = a[i];
  }
})(exports,
/******/
function (modules) {
  // webpackBootstrap

  /******/
  // The module cache

  /******/
  var installedModules = {};
  /******/

  /******/
  // The require function

  /******/

  function __webpack_require__(moduleId) {
    /******/

    /******/
    // Check if module is in cache

    /******/
    if (installedModules[moduleId]) {
      /******/
      return installedModules[moduleId].exports;
      /******/
    }
    /******/
    // Create a new module (and put it into the cache)

    /******/


    var module = installedModules[moduleId] = {
      /******/
      i: moduleId,

      /******/
      l: false,

      /******/
      exports: {}
      /******/

    };
    /******/

    /******/
    // Execute the module function

    /******/

    modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
    /******/

    /******/
    // Flag the module as loaded

    /******/

    module.l = true;
    /******/

    /******/
    // Return the exports of the module

    /******/

    return module.exports;
    /******/
  }
  /******/

  /******/

  /******/
  // expose the modules object (__webpack_modules__)

  /******/


  __webpack_require__.m = modules;
  /******/

  /******/
  // expose the module cache

  /******/

  __webpack_require__.c = installedModules;
  /******/

  /******/
  // define getter function for harmony exports

  /******/

  __webpack_require__.d = function (exports, name, getter) {
    /******/
    if (!__webpack_require__.o(exports, name)) {
      /******/
      Object.defineProperty(exports, name, {
        enumerable: true,
        get: getter
      });
      /******/
    }
    /******/

  };
  /******/

  /******/
  // define __esModule on exports

  /******/


  __webpack_require__.r = function (exports) {
    /******/
    if (typeof Symbol !== 'undefined' && Symbol.toStringTag) {
      /******/
      Object.defineProperty(exports, Symbol.toStringTag, {
        value: 'Module'
      });
      /******/
    }
    /******/


    Object.defineProperty(exports, '__esModule', {
      value: true
    });
    /******/
  };
  /******/

  /******/
  // create a fake namespace object

  /******/
  // mode & 1: value is a module id, require it

  /******/
  // mode & 2: merge all properties of value into the ns

  /******/
  // mode & 4: return value when already ns object

  /******/
  // mode & 8|1: behave like require

  /******/


  __webpack_require__.t = function (value, mode) {
    /******/
    if (mode & 1) value = __webpack_require__(value);
    /******/

    if (mode & 8) return value;
    /******/

    if (mode & 4 && typeof value === 'object' && value && value.__esModule) return value;
    /******/

    var ns = Object.create(null);
    /******/

    __webpack_require__.r(ns);
    /******/


    Object.defineProperty(ns, 'default', {
      enumerable: true,
      value: value
    });
    /******/

    if (mode & 2 && typeof value != 'string') for (var key in value) {
      __webpack_require__.d(ns, key, function (key) {
        return value[key];
      }.bind(null, key));
    }
    /******/

    return ns;
    /******/
  };
  /******/

  /******/
  // getDefaultExport function for compatibility with non-harmony modules

  /******/


  __webpack_require__.n = function (module) {
    /******/
    var getter = module && module.__esModule ?
    /******/
    function getDefault() {
      return module['default'];
    } :
    /******/
    function getModuleExports() {
      return module;
    };
    /******/

    __webpack_require__.d(getter, 'a', getter);
    /******/


    return getter;
    /******/
  };
  /******/

  /******/
  // Object.prototype.hasOwnProperty.call

  /******/


  __webpack_require__.o = function (object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
  };
  /******/

  /******/
  // __webpack_public_path__

  /******/


  __webpack_require__.p = "";
  /******/

  /******/

  /******/
  // Load entry module and return exports

  /******/

  return __webpack_require__(__webpack_require__.s = "./src/main.js");
  /******/
}(
/************************************************************************/

/******/
{
  /***/
  "./src/main.js":
  /*!*********************!*\
    !*** ./src/main.js ***!
    \*********************/

  /*! exports provided: SCREEN_SIZE, screenWidth, responsiveComponent */

  /***/
  function srcMainJs(module, __webpack_exports__, __webpack_require__) {
    "use strict";

    __webpack_require__.r(__webpack_exports__);
    /* harmony import */


    var _screen_width_broadcaster__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
    /*! ./screen-width.broadcaster */
    "./src/screen-width.broadcaster.js");
    /* harmony reexport (safe) */


    __webpack_require__.d(__webpack_exports__, "SCREEN_SIZE", function () {
      return _screen_width_broadcaster__WEBPACK_IMPORTED_MODULE_0__["SCREEN_SIZE"];
    });
    /* harmony reexport (safe) */


    __webpack_require__.d(__webpack_exports__, "screenWidth", function () {
      return _screen_width_broadcaster__WEBPACK_IMPORTED_MODULE_0__["screenWidth"];
    });
    /* harmony import */


    var _responsive_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
    /*! ./responsive-component */
    "./src/responsive-component.js");
    /* harmony reexport (safe) */


    __webpack_require__.d(__webpack_exports__, "responsiveComponent", function () {
      return _responsive_component__WEBPACK_IMPORTED_MODULE_1__["responsiveComponent"];
    });
    /***/

  },

  /***/
  "./src/responsive-component.js":
  /*!*************************************!*\
    !*** ./src/responsive-component.js ***!
    \*************************************/

  /*! exports provided: responsiveComponent */

  /***/
  function srcResponsiveComponentJs(module, __webpack_exports__, __webpack_require__) {
    "use strict";

    __webpack_require__.r(__webpack_exports__);
    /* harmony export (binding) */


    __webpack_require__.d(__webpack_exports__, "responsiveComponent", function () {
      return responsiveComponent;
    });
    /* harmony import */


    var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
    /*! react */
    "react");
    /* harmony import */


    var react__WEBPACK_IMPORTED_MODULE_0___default =
    /*#__PURE__*/
    __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
    /* harmony import */


    var _screen_width_broadcaster__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
    /*! ./screen-width.broadcaster */
    "./src/screen-width.broadcaster.js");

    var _jsxFileName = '/Users/santi/code/responsive-component/packages/lib/src/responsive-component.js';

    var _createClass = function () {
      function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }

      return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
      };
    }();

    function _defineProperty(obj, key, value) {
      if (key in obj) {
        Object.defineProperty(obj, key, {
          value: value,
          enumerable: true,
          configurable: true,
          writable: true
        });
      } else {
        obj[key] = value;
      }

      return obj;
    }

    function _classCallCheck(instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    }

    function _possibleConstructorReturn(self, call) {
      if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      }

      return call && (typeof call === "object" || typeof call === "function") ? call : self;
    }

    function _inherits(subClass, superClass) {
      if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
      }

      subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
          value: subClass,
          enumerable: false,
          writable: true,
          configurable: true
        }
      });
      if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }

    var responsiveComponent = function responsiveComponent(Component) {
      return function (_React$PureComponent) {
        _inherits(ResponsiveComponent, _React$PureComponent);

        function ResponsiveComponent() {
          var _ref;

          var _temp, _this, _ret;

          _classCallCheck(this, ResponsiveComponent);

          for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ResponsiveComponent.__proto__ || Object.getPrototypeOf(ResponsiveComponent)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            screenWidth: _screen_width_broadcaster__WEBPACK_IMPORTED_MODULE_1__["screenWidth"].current
          }, _this._handleScreenSize = function (size) {
            return _this.setState({
              screenWidth: size
            });
          }, _temp), _possibleConstructorReturn(_this, _ret);
        }

        _createClass(ResponsiveComponent, [{
          key: 'componentDidMount',
          value: function componentDidMount() {
            _screen_width_broadcaster__WEBPACK_IMPORTED_MODULE_1__["screenWidth"].emitter.subscribe(this._handleScreenSize);
          }
        }, {
          key: 'componentWillUnmount',
          value: function componentWillUnmount() {
            _screen_width_broadcaster__WEBPACK_IMPORTED_MODULE_1__["screenWidth"].emitter.unsubscribe(this._handleScreenSize);
          }
        }, {
          key: 'render',
          value: function render() {
            var screenWidth = this.state.screenWidth;
            var sizeClass = void 0;

            if (screenWidth.isBiggerOrEqualTo(_screen_width_broadcaster__WEBPACK_IMPORTED_MODULE_1__["SCREEN_SIZE"].TABLET_SM)) {
              if (screenWidth.isBiggerOrEqualTo(_screen_width_broadcaster__WEBPACK_IMPORTED_MODULE_1__["SCREEN_SIZE"].TABLET_MD)) sizeClass = 'screen-big';else sizeClass = 'screen-md';
            } else sizeClass = 'screen-small';

            return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(Component, Object.assign({}, this.props, _defineProperty({
              sizeClass: sizeClass,
              isMobile: sizeClass === 'screen-small',
              __source: {
                fileName: _jsxFileName,
                lineNumber: 31
              },
              __self: this
            }, '__self', this)));
          }
        }]);

        return ResponsiveComponent;
      }(react__WEBPACK_IMPORTED_MODULE_0___default.a.PureComponent);
    };
    /***/

  },

  /***/
  "./src/screen-width.broadcaster.js":
  /*!*****************************************!*\
    !*** ./src/screen-width.broadcaster.js ***!
    \*****************************************/

  /*! exports provided: SCREEN_SIZE, screenWidth */

  /***/
  function srcScreenWidthBroadcasterJs(module, __webpack_exports__, __webpack_require__) {
    "use strict";

    __webpack_require__.r(__webpack_exports__);
    /* harmony export (binding) */


    __webpack_require__.d(__webpack_exports__, "SCREEN_SIZE", function () {
      return SCREEN_SIZE;
    });
    /* harmony export (binding) */


    __webpack_require__.d(__webpack_exports__, "screenWidth", function () {
      return screenWidth;
    });
    /* harmony import */


    var _blast_engine_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
    /*! @blast-engine/utils */
    "@blast-engine/utils");
    /* harmony import */


    var _blast_engine_utils__WEBPACK_IMPORTED_MODULE_0___default =
    /*#__PURE__*/
    __webpack_require__.n(_blast_engine_utils__WEBPACK_IMPORTED_MODULE_0__);

    var _createClass = function () {
      function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }

      return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
      };
    }();

    var _THRESHOLDS_CONFIG;

    function _classCallCheck(instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    }

    function _defineProperty(obj, key, value) {
      if (key in obj) {
        Object.defineProperty(obj, key, {
          value: value,
          enumerable: true,
          configurable: true,
          writable: true
        });
      } else {
        obj[key] = value;
      }

      return obj;
    }

    var SCREEN_SIZE = {
      DESKTOP_LG: 'DESKTOP_LG',
      DESKTOP_MD: 'DESKTOP_MD',
      DESKTOP_SM: 'DESKTOP_SM',
      TABLET_LG: 'TABLET_LG',
      TABLET_MD: 'TABLET_MD',
      TABLET_SM: 'TABLET_SM',
      PHONE_LG: 'PHONE_LG',
      PHONE_MD: 'PHONE_MD',
      PHONE_SM: 'PHONE_SM',
      SMALLEST: 'SMALLEST' // from zero till first threshold
      // dont include limits (smallest)

    };
    var THRESHOLDS_CONFIG = (_THRESHOLDS_CONFIG = {}, _defineProperty(_THRESHOLDS_CONFIG, SCREEN_SIZE.DESKTOP_LG, 1600), _defineProperty(_THRESHOLDS_CONFIG, SCREEN_SIZE.DESKTOP_MD, 1400), _defineProperty(_THRESHOLDS_CONFIG, SCREEN_SIZE.DESKTOP_SM, 1200), _defineProperty(_THRESHOLDS_CONFIG, SCREEN_SIZE.TABLET_LG, 1100), _defineProperty(_THRESHOLDS_CONFIG, SCREEN_SIZE.TABLET_MD, 600), _defineProperty(_THRESHOLDS_CONFIG, SCREEN_SIZE.TABLET_SM, 500), _defineProperty(_THRESHOLDS_CONFIG, SCREEN_SIZE.PHONE_LG, 400), _defineProperty(_THRESHOLDS_CONFIG, SCREEN_SIZE.PHONE_MD, 360), _defineProperty(_THRESHOLDS_CONFIG, SCREEN_SIZE.PHONE_SM, 300), _THRESHOLDS_CONFIG);
    var thresholds = Object(_blast_engine_utils__WEBPACK_IMPORTED_MODULE_0__["kv"])(THRESHOLDS_CONFIG).map(function (_ref) {
      var size = _ref.k,
          minWidth = _ref.v;
      return {
        size: size,
        minWidth: minWidth
      };
    }).filter(function (_ref2) {
      var size = _ref2.size;
      return size !== SCREEN_SIZE.SMALLEST;
    }).map(function (_ref3) {
      var size = _ref3.size,
          minWidth = _ref3.minWidth;
      return {
        size: size,
        minWidth: minWidth,
        query: window.matchMedia('only screen and (min-width: ' + minWidth + 'px)')
      };
    });
    var broadcaster = {
      current: null,
      emitter: new _blast_engine_utils__WEBPACK_IMPORTED_MODULE_0__["Emitter"](),
      isBiggerOrEqualTo: function isBiggerOrEqualTo(size) {
        if (!SCREEN_SIZE[size]) throw new Error('invalid size: ' + size);
        if (broadcaster.current.size === SCREEN_SIZE.SMALLEST) return false;
        var currentWidth = THRESHOLDS_CONFIG[broadcaster.current.size];
        var requestWidth = THRESHOLDS_CONFIG[size];
        return currentWidth >= requestWidth;
      }
    };

    var SizeWrapper = function () {
      function SizeWrapper(size) {
        _classCallCheck(this, SizeWrapper);

        this.size = size;
      }

      _createClass(SizeWrapper, [{
        key: 'isBiggerOrEqualTo',
        value: function isBiggerOrEqualTo(size) {
          if (!SCREEN_SIZE[size]) throw new Error('invalid size: ' + size);
          if (this.size === SCREEN_SIZE.SMALLEST) return false;
          var currentWidth = THRESHOLDS_CONFIG[this.size];
          var requestWidth = THRESHOLDS_CONFIG[size];
          return currentWidth >= requestWidth;
        }
      }]);

      return SizeWrapper;
    }();

    var update = function update() {
      var largestMatched = thresholds.reduce(function (largestMatched, t) {
        if (!t.query.matches) return largestMatched;
        if (!largestMatched || largestMatched.minWidth < t.minWidth) return t;
        return largestMatched;
      }, null);

      var broadcast = function broadcast(size) {
        broadcaster.current = new SizeWrapper(size);
        broadcaster.emitter.emit(broadcaster.current);
      };

      if (!largestMatched) {
        if (broadcaster.current !== SCREEN_SIZE.SMALLEST) broadcast(SCREEN_SIZE.SMALLEST);
      } else {
        if (!broadcaster.current || largestMatched.size !== broadcaster.current) broadcast(largestMatched.size);
      }
    };

    thresholds.forEach(function (t) {
      return t.query.addListener(update);
    });
    update();
    var screenWidth = broadcaster;
    /***/
  },

  /***/
  "@blast-engine/utils":
  /*!**************************************!*\
    !*** external "@blast-engine/utils" ***!
    \**************************************/

  /*! no static exports found */

  /***/
  function blastEngineUtils(module, exports) {
    module.exports = require("@blast-engine/utils");
    /***/
  },

  /***/
  "react":
  /*!************************!*\
    !*** external "react" ***!
    \************************/

  /*! no static exports found */

  /***/
  function react(module, exports) {
    module.exports = require("react");
    /***/
  }
  /******/

}));